import {
  getGetV8MongodbActiveSessionSqlTextQueryKey,
  getV8MongodbActiveSessionSqlText,
} from '@/api-client/mongodb/queries/mongodb-controller/mongodb-controller';
import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import { formatTimeRange } from '@/database/utils/format.utils';
import { DOCUMENT_TEXT_TYPE } from '@/database/adapter/openDetail.define';
import type { DocumentTextParams } from '../types';
import { mergeDetailInfo, parseSchema } from './utils';
import { documentTextSchema, type DocumentTextSchema } from './mongodb.schema';
import { getRequiredMap } from '@/common/utils/core/detailFieldMeta.utils';

export const getMongodbDocumentTextParams = ({
  detailInfo,
  fromTime,
  toTime,
  instanceId,
  period,
  useFieldValidation,
}: DocumentTextParams) => {
  const formattedTime = formatTimeRange({ fromTime, toTime });
  const timeInfo = period ? { period } : formattedTime;

  if (!useFieldValidation) {
    return {
      instanceId,
      ...timeInfo,
      sqlId: detailInfo.sqlId,
      sqlTextHashId: detailInfo.sqlTextHashId,
      operationId: detailInfo.operationId,
      document: detailInfo.document,
    };
  }

  const { data } = parseSchema<DocumentTextSchema>(
    documentTextSchema,
    mergeDetailInfo(detailInfo, instanceId),
    DOCUMENT_TEXT_TYPE,
  );

  return {
    instanceId: data.instanceId,
    ...timeInfo,
    sqlId: data.sqlId,
    sqlTextHashId: data.sqlTextHashId,
    operationId: data.operationId,
    document: data.document,
  };
};

export const fetchMongodbDocumentText = async ({
  frameName,
  abortController,
  ...rest
}: DocumentTextParams) => {
  const { document, ...params } = getMongodbDocumentTextParams({
    ...rest,
    useFieldValidation: true,
  });

  const {
    data: { data = [] },
  } = await getV8MongodbActiveSessionSqlText(
    params,
    { params: { frameName: frameName || FRAME_NAMES.DOCUMENT_WINDOW.FULL_TEXT } },
    abortController?.signal,
  );

  return (data[0] || {})[document] || null;
};

export const getMongodbDocumentTextQueryKey = (params: DocumentTextParams | null) => {
  if (!params) {
    return getGetV8MongodbActiveSessionSqlTextQueryKey();
  }

  const convertedParams = getMongodbDocumentTextParams({ ...params, useFieldValidation: false });

  return getGetV8MongodbActiveSessionSqlTextQueryKey(convertedParams);
};

export const mongoDBDocumentTextRequiredMap = getRequiredMap(documentTextSchema);
